import { menuItems } from "./menuItems"
import './header.css';
// to scroll to that point 
import { Link } from 'react-scroll';
const Hmenu = () => {
  return (
    
  <nav className="navbar navbar-expand-lg bg-dark navbar-dark">
  <div className="collapse navbar-collapse">
   <ul className="navbar nav">
    {menuItems.map((menu, index) => {
     return (
      <li className="menu-items" key={index}>
       <a href={menu.link} className="nav-link">{menu.title}</a>
      </li>
     );
    })}
   </ul>
  </div>
  </nav>
  )
}
export default Hmenu